module.exports = __webpack_public_path__ + "public/img/ico-tabbar-active-profile.40a73d4a.svg";